import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { ApiService } from '@env-lib/api/api.service'
import { LoadingModule } from '@loading-lib/loading.module'

@Component({
    selector: 'app-reset-password-dispatcher',
    template: '<app-loading-pin></app-loading-pin>',
    standalone: true,
    imports: [CommonModule, LoadingModule],
})
export class ResetPasswordDispatcherComponent {
    constructor(private api: ApiService) {
        window.location.href = this.api.auth.b2cPasswordReset
    }
}
